
import React, { useState, useEffect, Component, useRef } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Signin.module.scss";
import AuthService from "services/auth.service";
import LocalStorageService from "services/tokenlocalstorage.service";
import { useHistory, Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import cryptoJS from "crypto-js";
import { secret_encryption_key } from "components/common/Constants";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { MyEmailContext } from "context/emailContext";
import { Modal } from "@mui/material";
// import {privacyPolicyEP} from "screen/PPandTC/PrivacyPolicyEP";
import PrivacyPolicyPortal from "screen/PPandTC/PrivacyPolicyEP";
import TermsConditionsPortal from "screen/PPandTC/TermsConditionsEP";
export default function Signin(props) {
  // const MyEmailContextValue = React.useContext(MyEmailContext);

  const myEmailRef = useRef();
  const history = useHistory();
  const secretKey = secret_encryption_key;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState();
  const [error, setError] = useState();
  const [viewEye, setviewEye] = useState();
  const [passwordType, setPasswordType] = useState("password");
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleRemember = (e) => {
    setRemember(e.target.checked);
  };

  const keyboardEvents = (e) => {
    if (e.code == "Enter") {
      signin();
    }
  };
  const openTermsModal = () => {
    setTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setTermsModalOpen(false);
  };
  const openPrivacyModal = () => {
    setPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setPrivacyModalOpen(false);
  };

  useEffect(() => {
    function checkRemember() {
      if (LocalStorageService.get("remember") === "true") {
        setRemember(true);
        const secretKey = secret_encryption_key;
        setEmail(LocalStorageService.get("userName"));
        setPassword(
          cryptoJS.AES.decrypt(
            LocalStorageService.get("password"),
            secretKey
          ).toString(cryptoJS.enc.Utf8)
        );
      } else {
        setRemember(false);
      }
    }
    checkRemember();
  }, []);

  const signin = async () => {
    if (!email || !password) {
      setError("Email and Password is required");
      return;
    }
    if (!email) {
      setError("Please Enter Email");
      return;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)) {
      setError("Please enter valid email ID");
      return;
    } else {
      setError("");
    }
    if (!password) {
      setError("Please Enter Password");
      return;
    }
    const loggedUser = await AuthService.login(email, password);

    if (loggedUser?.data?.accessToken) {
      if (remember) {
        LocalStorageService.set("remember", true);
        LocalStorageService.set("userName", email);
        LocalStorageService.set(
          "password",
          cryptoJS.AES.encrypt(password, secretKey).toString()
        );
      } else {
        LocalStorageService.set("remember", false);
        LocalStorageService.remove("userName");
        LocalStorageService.remove("password");
      }
      const token = loggedUser?.data?.accessToken;
      setError();
      const decodedToken = jwt_decode(token);
      const usrRole = decodedToken["resource_access"]["login-app"]["roles"];
      const usrName = decodedToken["name"];
      const enterpriseName = decodedToken["group"];
      LocalStorageService.set("user-role", usrRole[0]);
      LocalStorageService.set("user-name", usrName);
      LocalStorageService.set("enterpriseName", enterpriseName);
      myEmailRef.current = email;
      history.push("/Dashboard");
    } else if (loggedUser?.data) {
      setError(JSON.stringify(loggedUser?.data?.message));
    }
  };
  if (LocalStorageService.getToken() && LocalStorageService.get("user-role")) {
    return <Redirect to={{ pathname: "/Dashboard" }} />;
  }
  return (
    <div
      className={`Signin ${cn(
        styles.block,
        styles.block_layout,
        styles.signin_container
      )}`}
      style={{
        backgroundImage: `url(${
          // require('assets/login_bg.jpg')
          require("assets/loginBackgrnd.png").default
        })`,
      }}
    >
      <div className={cn(styles.cover_block1, styles.cover_block1_layout)}>
        <div className={cn(styles.flex, styles.flex_layout)}>
          <div className={cn(styles.flex1, styles.flex1_layout)}>
            <div className={cn(styles.flex1_item)}>
              <div
                style={{
                  "--src": `url(${require("assets/jio-logo.png").default})`,
                }}
                className={cn(styles.icon, styles.icon_layout)}
              />
            </div>
            <div className={cn(styles.flex1_spacer)} />
            <h1 className={cn(styles.hero_title, styles.hero_title_layout)}>
              &nbsp;{"SwapUp"}
            </h1>
          </div>

          <h1 className={cn(styles.hero_title1, styles.hero_title1_layout)}>
            {"Login"}
          </h1>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Email*"}
          </h2>
          <input
            type="text"
            name="email"
            className={cn(styles.box1, styles.box1_layout)}
            required
            value={email}
            onChange={handleEmail}
            placeholder={"Please enter your email"}
            color="#8E8E8E"
            autoComplete="off"
          />
          <h2 className={cn(styles.medium_title, styles.medium_title_layout1)}>
            {"Password*"}
          </h2>
          <div className={cn(styles.box2)}>
            <input
              type={passwordType === "password" ? "password" : "text"}
              name="password"
              className={cn(styles.box1, styles.box1_layout)}
              required
              value={password}
              onChange={handlePassword}
              placeholder={"Please enter your password"}
              color="#8E8E8E"
              onKeyPress={keyboardEvents}
              autoComplete="off"
              // key={handlePassword}
            />
            <div className={cn(styles.eye_box)} onClick={togglePassword}>
              {passwordType === "password" ? <FiEyeOff /> : <FiEye />}
            </div>
          </div>
          <div
            className={cn(styles.flex2, styles.flex2_layout, styles.flex2_wrap)}
          >
            <div className={cn(styles.flex2_item)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex3_item)}>
                  <input
                    type="checkbox"
                    name="remember"
                    className={cn(styles.box4, styles.box4_layout)}
                    required
                    checked={remember}
                    onChange={handleRemember}
                  />
                </div>
                <div className={cn(styles.flex3_spacer)} />
                <div
                  className={cn(styles.text_body1, styles.text_body1_layout)}
                >
                  {"Keep me logged in"}
                </div>
              </div>
            </div>

            <div className={cn(styles.flex2_spacer1)} />
            <div className={cn(styles.mt10)}>
              <Link to="/ForgotPassword">
                <div className={cn(styles.text_body, styles.text_body_layout)}>
                  {"Forgot Password?"}
                </div>
              </Link>
            </div>
          </div>

          <button
            className={cn(
              styles.cover_block_layout_disabled,
              email !== "" && password !== ""
                ? styles.cover_block
                : styles.cover_block_disabled
            )}
            onClick={signin}
            disabled={email === "" || password === ""}
          >
            <h2
              className={cn(styles.medium_title1, styles.medium_title1_layout)}
            >
              {"Login"}
            </h2>
          </button>
          {error && (
            <p
              style={{
                textAlign: "center",
                marginBottom: "20px",
                color: "red",
              }}
            >
              {error}
            </p>
          )}
          <div className={cn(styles.TC_block)}>
          <p>By continuing, you agree to our<b onClick={openTermsModal} style={{cursor:"pointer"}}> Terms of use</b> and <b onClick={openPrivacyModal} style={{cursor:"pointer"}}>Privacy policy</b></p>
          </div>
          
          <Modal open={termsModalOpen} onClose={closeTermsModal}>
          <div className={cn(styles.modal_block)}>
         <TermsConditionsPortal/> 
         <button className={cn(styles.modal_button)} onClick={closeTermsModal}>close</button>    
        </div>
      </Modal>
      <Modal open={privacyModalOpen} onClose={closePrivacyModal}>
          <div className={cn(styles.modal_block)}>
         <PrivacyPolicyPortal/> 
         <button className={cn(styles.modal_button)} onClick={closePrivacyModal}>close</button>  
        </div>
      </Modal>
          
        </div>
      </div>
    </div>
  );
}

Signin.inStorybook = true;
